import { createContext } from 'react';
var throwError = function () {
    throw new Error('Fluxible component context not found. Wrap your component with FluxibleProvider.');
};
export var FluxibleContext = createContext({
    executeAction: throwError,
    getStore: throwError,
    trackEvent: throwError,
});
